import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContentText from "@material-ui/core/DialogContentText";
import Button from "@material-ui/core/Button";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import classes from "./termsAndConditions.module.css";

export default function TermsAndConditions(props) {
  const [privacyDisplay, setPrivacyDisplay] = useState(false);
  const [tAndCsDisplay, settAndCsDisplay] = useState(false);
  const [EULADisplay, setEULADisplay] = useState(false);

  return (
    <Dialog
      fullWidth={true}
      maxWidth={"md"}
      open={props.open}
      // onClose={this.readDialogClose}
    >
      <DialogContentText className="padding-5" id="alert-dialog-description">
        <div>
          <ExpansionPanel expanded={true}>
            <ExpansionPanelSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2a-content"
              id="panel2a-header"
            >
              <Typography className="read-title">
                <b>Disclaimer</b>
              </Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <Typography className="read-content">
                <p className={classes.textPrivacyImportantCenter}>Disclaimer</p>
                <div className="privacy-policies">
                  <div className="introduction">
                    <p className={classes.textPrivacyImportant}>
                      At the time of sign-up, If you are under 16 years of age,
                      your parents or guardian supervision is mandatory. We
                      assume that you are sharing your information with your
                      consent.
                    </p>
                    <p className={classes.textPrivacyImportant}>
                      To serve you better, at this stage, we ask your academic
                      information and conduct IQ tests, Visual memorizing tests,
                      psychological tests to prepare a comprehensive, methodical
                      cogent learning path. Your behavioural data and facial,
                      emotions data is processed by our Analytics to know the
                      effectiveness of the lesson taught in the class. We make
                      sure that the student data is secure and shall not be sold
                      to a third-party.
                    </p>
                    <p className={classes.textPrivacyImportant}>
                      The User account is person-specific. It is a user’s
                      responsibility to keep the password secure and not to be
                      shared with anyone. <br />
                      Make sure you proceed with the sign-up and share your
                      information only when you agree with our Terms of Use and
                      Privacy policy. You may opt-out at any time.
                    </p>
                  </div>
                </div>
              </Typography>
            </ExpansionPanelDetails>
          </ExpansionPanel>
          <ExpansionPanel>
            <ExpansionPanelSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography className="read-title">
                <b>Terms & Conditions</b>
              </Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <Typography className="read-content">
                <p className={classes.textPrivacyImportantCenter}>
                  Terms of Use
                </p>
                <div className="privacy-policies">
                  <div className="introduction">
                    <p className={classes.textPrivacyContext}>
                      1. Acceptance of Terms of Use
                    </p>
                    <p className={classes.textPrivacyNormal}>
                      These terms of use (Terms) constitute a legally binding
                      agreement between User or you and the company regarding
                      your use of the KNEURA website. i.e.{" "}
                      <a
                        className={classes.textPrivacyLink}
                        href="https://www.kneura.com"
                        target="_blank"
                      >
                        www.kneura.com
                      </a>{" "}
                      (the Site), and KNEURA products /mobile application
                      (“App”) and associated services.)
                    </p>
                    <div className={tAndCsDisplay ? "" : classes.toggleDisplay}>
                      <p className={classes.textPrivacyNormal}>
                        “You” or “User” means any person who accesses, uses or
                        avails this site, App or the services of the company for
                        publishing sharing, transacting, displaying, or
                        uploading information or views and includes another
                        person jointly participating in using the site or the
                        app of the company.
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        By accessing the Site, App or Service, you consent to
                        these Terms. You hereby represent and warrant to the
                        Company that you are at least eighteen (18) years of age
                        or above and are capable of entering, adhering and
                        fulfilling to the Terms and condition herein and that
                        you agree to be bound by the following terms and
                        conditions. While Individuals under the age of 18 may
                        utilize the Products and services only with the guidance
                        and supervision of their parents and / Legal guardians.
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        You must not use KNEURA products and platforms if you
                        have any objection to any of these Website Terms And
                        Conditions or any condition laid in the privacy policy.
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        The app and the site should be used by anyone eligible
                        to enter into a valid contract, and you must not use the
                        app and the site if you a minor. You warrant that you
                        possess the legal right to use payment options for any
                        purchase.
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        The company reserves the right at its discretion to
                        change, modify, add, or remove these Terms at any time
                        by posting the amended Terms. Please check these Terms
                        periodically for change. Your continued use of the App
                        and Website after the posting of changes constitutes
                        your binding acceptance of such changes, Also, when
                        using any particular service, you may be subject to any
                        posted guidelines or rules applicable to such services.
                        If you do not agree with the Terms, please do not use
                        this site or the App.
                      </p>
                      <p className={classes.textPrivacyContext}>
                        2. Registration and Availability
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        To register for KNEURA App you may be required to open
                        an account by completing the registration process (by
                        providing with current, complete and accurate
                        information as prompted by registration form). You
                        expressly agree to absolve the Company and/or the KNEURA
                        Site, App or service of any responsibility/liability in
                        this regard. By registering, you agree to the Terms
                        stated herein and in addition to any other specific
                        terms which shall be posted at an appropriate location
                        of the app and the site. Each registration is for a
                        single individual user only.
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        To access the KNEURA App, you will be asked to input
                        your email id and phone number, as chosen by you during
                        your registration, to establish a unique identity for
                        you. If the Company reasonably believes that an account
                        is being misused in any manner, the Company shall
                        reserve the right to cancel access rights immediately
                        without notice, and block access to all its users.
                        Furthermore, you shall be entirely responsible for any
                        activities that occur under your account. You agree to
                        notify the Company immediately of any unauthorized use
                        of your account or any other breach of security. The
                        Company will not be liable for any loss that you may
                        incur as a result of someone else using your account,
                        however, you could be held liable for losses incurred by
                        the Company or another party due to someone else using
                        your account.
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        <span className={classes.textPrivacyImportant}>
                          Availability:
                        </span>
                        The data provided through KNEURA App will change from
                        time to time. The quality of app service may vary from
                        device to device and may be affected by a variety of
                        factors, such as your location, speed of your internet
                        connection, etc. You are responsible for all internet
                        access charges.
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        Please check with your internet provider for information
                        on possible Internet data usage changers.
                      </p>

                      <p className={classes.textPrivacyContext}>
                        3. Intellectual Property Rights
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        Other than the content you own, which you may have opted
                        to include on the App, under these Terms, We, KNEURA and
                        affiliates and/or its licensors own all rights to the
                        intellectual property and material contained in the App,
                        and all such rights are reserved. All programs,
                        services, processes, designs, software, technologies,
                        trademarks, and trade names and inventions appearing or
                        accessible via the website or the KNEURA Platform, are
                        the property of KNEURA or its licensors.
                      </p>

                      <p className={classes.textPrivacyContext}>4. Download.</p>
                      <p className={classes.textPrivacyNormal}>
                        In the event you download the App from the site, the
                        App, including any files, images incorporated in or
                        generated by the App, and data accompanying the App
                        (collectively, the "App") are licensed to you by Us. The
                        use of the App is subject to the license terms in the
                        Software License Agreement that accompanies the App. We
                        do not transfer the title of the App/software to you.
                        KNEURA retains complete title to the app/Software/site
                        and all intellectual property rights therein. You may
                        not redistribute, sell, decompile, reverse engineer,
                        disassemble, or otherwise reduce the App to a
                        human-readable form.
                      </p>

                      <p className={classes.textPrivacyContext}>
                        5. Ordering and Contracting
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        <span className={classes.textPrivacyImportant}>
                          5.1
                        </span>{" "}
                        You can place an order of our products from the site, or
                        send an e-mail to us. You agree that all agreements,
                        notices, disclosures and other communications that we
                        provide to you electronically satisfy any legal
                        requirement that such communications be in writing. This
                        condition does not affect your statutory rights related
                        to electronic communications. You are providing your
                        consent to receive communications electronically from us
                        concerning your purchase of our products.
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        <span className={classes.textPrivacyImportant}>
                          5.2
                        </span>{" "}
                        You agree to abide by the Terms and Conditions while
                        placing an order on the website. Prior to the
                        confirmation or acceptance of an order and/or completion
                        of purchase require the verification of information
                        provided by you. While submitting your order you shall
                        have a privilege to review such order. Any corrections
                        you may seek at this stage will be allowed to correct
                        the input error.
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        <span className={classes.textPrivacyImportant}>
                          5.3
                        </span>{" "}
                        Order placed through the website constitutes an offer to
                        purchase a product and/or services listed on the
                        website. We, KNEURA reserve the discretionary right to
                        accept or reject the offer placed on the website. We
                        deliver within a selected delivery area within the You
                        will receive an email confirmation about the acceptance
                        of your offer.
                      </p>

                      <p className={classes.textPrivacyContext}>
                        6. Third-Party Content
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        <span className={classes.textPrivacyImportant}>
                          6.1
                        </span>{" "}
                        KNEURA has made available the third-party content by way
                        of search results to you. Subject to your compliance
                        with Terms herein, KNEURA does not claim any ownership
                        right or any other right in the third-party content
                        (digital or otherwise).
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        Only search results are made available to you to access
                        third-party content available with a limited,
                        non-exclusive, non-transferable license, to
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        (a) access and view any such Content solely for your
                        personal and non-commercial purposes and
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        (b) access and view any such content to which you
                        permitted to access, solely for your personal and
                        non-commercial purposes. You have no right to sublicense
                        the license rights granted in this section.
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        <span className={classes.textPrivacyImportant}>
                          6.2
                        </span>{" "}
                        You will not copy, adapt, modify, prepare derivative
                        works, sell, distribute, license, transfer, publicly
                        perform, transmit, broadcast or otherwise exploit the
                        Site, Application, Services, or Collective Content,
                        except as expressly permitted in these Terms. No
                        licenses or rights are granted to you by implication or
                        otherwise under any intellectual property rights owned
                        or controlled by us or its licensors, except for the
                        licenses and rights expressly granted in these Terms.
                      </p>

                      <p className={classes.textPrivacyContext}>
                        7. Member Content
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        <span className={classes.textPrivacyImportant}>
                          7.1
                        </span>{" "}
                        We may permit you to post, publish, submit or transmit
                        any Content(digital or otherwise). By making any such
                        content available on or through the Site, Services, and
                        Application, you hereby grant to KNEURA a worldwide,
                        irrevocable, perpetual (or for the term of the
                        protection), non-exclusive, transferable, royalty-free
                        license, with the right to sublicense, to use, view,
                        copy, adapt, modify, distribute, license, sell,
                        transfer, publicly display, publicly perform, transmit,
                        stream, broadcast, access, view, and otherwise exploit
                        such content on, through, utilizing or to promote or
                        market the Site, Application and Services.
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        <span className={classes.textPrivacyImportant}>
                          7.2
                        </span>{" "}
                        You acknowledge and agree that you are solely
                        responsible for digital content that you make avail
                        through the Site, Service, and Application. KNEURA does
                        not claim any ownership rights in any such Content and
                        nothing in these Terms will be deemed to restrict any
                        rights that you may have to use and exploit any such
                        Content owned by you.
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        <span className={classes.textPrivacyImportant}>
                          7.3
                        </span>{" "}
                        You acknowledge and agree that you either are the sole
                        and exclusive owner of any Content(digital or otherwise)
                        that you make available through the Site, Services, and
                        Application or you have all rights, licenses, consent
                        that are necessary to grant to KNEURA the rights in such
                        content as contemplated under these Terms.
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        <span className={classes.textPrivacyImportant}>
                          7.4
                        </span>{" "}
                        You represent and warrants that neither of your any or
                        all Content(digital or otherwise) nor your posting,
                        uploading, publication, submission or transmittal of
                        such Content or KNEURA use of Content (or any portion
                        thereof) on, through or utilizing the Site, Application,
                        the Services or KNEURA promotional campaigns will
                        infringe, misappropriate or violate a third party's
                        patent, copyright, trademark, trade secret, moral rights
                        or other proprietary or intellectual property rights, or
                        rights of publicity or privacy, or result in the
                        violation of any applicable law or regulation.
                      </p>

                      <p className={classes.textPrivacyContext}>
                        8. Feedback and Information
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        Any feedback you provide at the app and the site, by
                        electronic mail or otherwise, including data, questions,
                        comments, suggestions or the like shall be deemed to be
                        non-confidential and non-proprietary.
                      </p>

                      <p className={classes.textPrivacyContext}>
                        9. No warranties
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        We do make no express or implied representations or
                        warranties, of any kind related to the site or the
                        materials contained on the site and the App.
                        Additionally, nothing contained on the site shall be
                        construed as providing consult or advice to you.The
                        website and Services made available to you with a
                        commercially reasonable level of skill and care and
                        without warranty of any kind, either express or implied.
                        Without limiting the foregoing, neither KNEURA nor its
                        suppliers or distributors explicitly make any specific
                        promises, warranties or undertakings about the Services,
                        disclaims any warranties of merchantability, fitness for
                        a particular purpose, non-infringement, and any
                        warranties arising out of course of dealing or usage of
                        trade.
                      </p>
                      <p className={classes.textPrivacyImportant}>
                        KNEURA PROVIDE THE SERVICES “AS IS”.
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        Some jurisdictions provide for certain warranties, like
                        the implied warranty of merchantability, fitness for a
                        particular purpose and non-infringement. To the extent
                        permitted by law, we exclude all warranties.
                      </p>

                      <p className={classes.textPrivacyContext}>
                        10. Limitation of liability.
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        In no event will KNEURA, its officers, directors, and
                        employees, be liable for any damages, including without
                        direct and indirect incidental and consequential
                        damages, loss of expense, loss of business, business
                        interruption, or loss of business opportunity in
                        connection with any product, purchase order, service.
                        The foregoing does not affect your non-excludable
                        statutory rights and only applies to the extent
                        permitted by the applicable law. In no event shall
                        KNEURA's total liability to you for all damages, losses,
                        and causes of action (whether in contract, tort
                        (including but not limited to negligence) or otherwise)
                        exceed the amount paid by you, if any, for accessing the
                        app and the site.
                      </p>

                      <p className={classes.textPrivacyContext}>
                        11. Indemnification
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        You hereby indemnify to the fullest extent KNEURA from
                        and against any liabilities, costs, demands, causes of
                        action, damages and expenses (including reasonable
                        attorney’s fees) arising out of or in any way related to
                        your breach of any of the provisions of these Terms.
                      </p>

                      <p className={classes.textPrivacyContext}>
                        12. Severability
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        If any provision of these Terms is found to be
                        unenforceable or invalid under any applicable law, such
                        unenforceability or invalidity shall not render these
                        Terms unenforceable or invalid as a whole, and such
                        provisions shall be deleted without affecting the
                        remaining provisions herein.
                      </p>

                      <p className={classes.textPrivacyContext}>
                        13. Variation of Terms
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        The Contents, webpages or/and entire website may change
                        subject to provide a better user experience. The terms
                        may also change, subject to revision of Terms as it sees
                        fit, and by using the site and the app you are expected
                        to review such Terms on regularly to ensure you
                        understand all terms and conditions governing the use of
                        the app.
                      </p>

                      <p className={classes.textPrivacyContext}>
                        14. Suspension or Termination of account
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        If we have reasonable grounds to suspect that
                        information provided by you is inaccurate, false, or not
                        in accordance with the Terms of Use Privacy policy and
                        EULA or in case of any suspicious or fraudulent activity
                        from your account, we shall have the right to
                        indefinitely suspend or terminate or block access to
                        your account. You are solely responsible to keep your
                        OTP, Debit card, Credit card details and bank account
                        details confidential.
                      </p>

                      <p className={classes.textPrivacyContext}>
                        15. No Waiver
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        <span className={classes.textPrivacyImportant}>
                          15.1
                        </span>{" "}
                        The failure to enforce a right or waiver of a breach of
                        any provisions under the terms & conditions will not
                        constitute a waiver of future enforcement of that right
                        or provision.
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        <span className={classes.textPrivacyImportant}>
                          15.2
                        </span>{" "}
                        The waiver of any such right or provision will be
                        effective only if in writing by an authorized
                        representative of KNEURA.
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        <span className={classes.textPrivacyImportant}>
                          15.3
                        </span>{" "}
                        The terms and conditions contained herein shall be
                        presumed to be enforceable, and any reading causing
                        unenforceability shall yield to construction permitting
                        enforcement. If any single term or clause shall be found
                        unenforceable, it shall be severed, and the remaining
                        term or clause and clauses enforced. Except as expressly
                        outlined in these Terms, the exercise by either party of
                        any of its remedies under these Terms will be without
                        prejudice to its other remedies under these Terms or
                        otherwise.
                      </p>

                      <p className={classes.textPrivacyContext}>
                        16. Entire Agreement
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        These Terms, including any legal notices and disclaimers
                        contained on the app or the site, constitute the entire
                        agreement between KNEURA and you in relation to your use
                        of the app and the site and supersede all prior
                        agreements and understandings concerning the same.
                      </p>

                      <p className={classes.textPrivacyContext}>
                        17. Governing Law & Jurisdiction
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        <span className={classes.textPrivacyImportant}>
                          17.1
                        </span>{" "}
                        These Terms will be governed by and construed per the
                        laws of the State of India, and you submit to the
                        non-exclusive jurisdiction of the state and federal
                        courts located in New Delhi, India for the resolution of
                        any disputes. Any dispute, claim or controversy arising
                        out of or relating to this Terms including the
                        determination of the scope or applicability of this
                        Terms to arbitrate, or your use of the Application or
                        information to which it gives access, shall be
                        determined by arbitration in India.
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        <span className={classes.textPrivacyImportant}>
                          17.2{" "}
                        </span>
                        Arbitration shall be conducted under the Arbitration and
                        Conciliation Act, 1996. All proceedings of such
                        arbitration, including, without limitation, any awards,
                        shall be in the English language. The award shall be
                        final and binding on the parties to the dispute.
                      </p>
                    </div>
                  </div>
                </div>

                <p
                  className="link"
                  onClick={() => settAndCsDisplay(!tAndCsDisplay)}
                >
                  {tAndCsDisplay ? "Read Less" : "Read More"}
                </p>
              </Typography>
            </ExpansionPanelDetails>
          </ExpansionPanel>
          <ExpansionPanel>
            <ExpansionPanelSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2a-content"
              id="panel2a-header"
            >
              <Typography className="read-title">
                <b>Privacy Policies</b>
              </Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <Typography className="read-content">
                <p className={classes.textPrivacyImportantCenter}>
                  Privacy Policies
                </p>
                <div className="privacy-policies">
                  <div className="introduction">
                    <p className={classes.textPrivacyContext}>
                      1. Introduction
                    </p>
                    <p className={classes.textPrivacyImportant}>
                      KNEURA is committed to safeguarding the privacy of users
                      (“User”, “Individual/ Entity” or “You”).
                    </p>
                    <p className={classes.textPrivacyNormal}>
                      This privacy policy explains our policy towards clear and
                      transparent use, collection, disclosure and transfer of
                      your information to our subsidiary and/or affiliate(s)
                      (collectively referred to as the "Company" or “We, Us,
                      Our”).
                    </p>
                    <div
                      className={privacyDisplay ? "" : classes.toggleDisplay}
                    >
                      <p className={classes.textPrivacyNormal}>
                        The information provided by you will help us serve you
                        better and provide you a better product.
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        This Privacy Policy does not apply to any third-party
                        applications or software that integrates with the
                        Services through the KNEURA platform ("Third Party
                        Services"), or any other third party products, services
                        or businesses.
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        We encourage you to review this Privacy Policy to stay
                        informed. You will be deemed to have accepted the
                        changes in any revised Privacy Policy by your continued
                        use of the Application.
                      </p>
                      <p className={classes.textPrivacyContext}>
                        2. What is "Personal Data"?
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        Any information which identifies You, including
                        information such as your name, phone number, email
                        address, company name (if applicable) and specific
                        information about you as a user (and not any other
                        person) that we either hold to. Some data falls into a
                        category known as Special Category Data(personal) where
                        usually the processing of that data can only be
                        undertaken with your consent.
                      </p>
                      <p className={classes.textPrivacyContext}>
                        3. What is Special Category data?
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        Special Category Data(personal) is data that identifies
                        particular characteristics and where your privacy
                        deserves special protection. Personal Data Revealing
                        your ethnicity, religious beliefs, trade union
                        membership, political opinion and Data Concerning a
                        person’s health and sexual orientation are examples of
                        Special categories of data.
                      </p>
                      <p className={classes.textPrivacyContext}>
                        4. What data we collect
                      </p>
                      <p className={classes.textPrivacyImportant}>
                        a) Personal Information
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        We only collect and hold information relevant to the
                        purpose of our dealings with you lawfully. Processing
                        such information subsequently carried out by us in
                        pursuance of our legitimate interest, for the purpose of
                        entering into a valid contract and subsequent provision
                        of services under the contract. We collect, hold and
                        process such information in the way we describe within
                        the policy. We make individuals aware of our policy in
                        reference to our holding and any processing of that
                        person's information at the purpose of collection of the
                        Data concerned.
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        List of Personal information we may collect:
                      </p>
                      <ul className={classes.textPrivacyNormal}>
                        <li className={classes.textPrivacyNormal}>
                          Personal information includes name, username, e-mail
                          address, telephone number.
                        </li>
                        <li className={classes.textPrivacyNormal}>
                          Age, gender and date of birth, etc.
                        </li>
                        <li className={classes.textPrivacyNormal}>
                          Name of organization, postal address, country or area.{" "}
                        </li>
                        <li className={classes.textPrivacyNormal}>
                          Access log files, cookies and other information
                          collected upon your visit to this website.
                        </li>
                      </ul>
                      <p className={classes.textPrivacyNormal}>
                        You may have been re-directed to this Policy through a
                        weblink we provided you with the intention to make you
                        aware of our policy in connection to our holding and
                        processing of your data at the point of collection of
                        such personal information.
                      </p>

                      <p className={classes.textPrivacyContext}>
                        5. How we collect Personal information
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        We may collect your Personal information at the purpose
                        you make an inquiry of KNEURA Products. This includes
                        any telephone inquiry you may make and inquiries that we
                        receive at an event including marketing activities we
                        conduct. Certain information may already be held by us
                        once you make contact if you’ve researched/inquired
                        about our business and product but until you contact us
                        will have been held on an anonymized basis.
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        By providing us with your business card or completing an
                        inquiry/contact form offered to you by us we’ll
                        communicate you assuming that you simply allow us that
                        we do so. We’ll invite you to consent to our retaining
                        of your information and therefore the consent you’ll
                        provide could also be withdrawn at any time by
                        contacting :{" "}
                        <a
                          className={classes.textPrivacyLink}
                          href="mailto:info@kneura.com"
                        >
                          info@kneura.com
                        </a>{" "}
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        Initially, your personal details are going to be
                        processed in these circumstances on the idea that it is
                        in our legitimate interest to interact with individuals
                        and organizations who are interested in KNEURA products
                        and services and what we do within the education domain.
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        Thereafter we will only retain your personal information
                        if we are entitled to do so based upon you have freely
                        consented to further communication otherwise you
                        agreeing to pilot the KNEURA Learning Platform.
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        When it is communicated to us that you simply wish to
                        receive information from us we will accordingly only
                        retain your information on a basis that entitles us to
                        thereafter hold and use that Personal information with
                        an express consent provided by you to us holding the
                        information and for every purpose that we then shall use
                        that information. If you sign up for any training event
                        or conference we also require personal information so
                        that we can communicate with you and prepare for your
                        involvement in the event.
                      </p>

                      <p className={classes.textPrivacyContext}>
                        6. Why we collect personal information
                      </p>
                      <p className={classes.textPrivacyImportant}>
                        a) To provide better service.
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        We collect personal information from you to understand
                        your needs to serve you better. In connection with your
                        subscription to the KNEURA platform you may, for
                        instance, use the services to grant and take away access
                        to, assign roles and configure settings, create student
                        profiles, modify, export, share and remove your Data and
                        otherwise apply its policies to the Services.E.g.: for
                        purposes associated with the activation, billing,
                        support, updates, troubleshoot and resolve problems,
                        repair & maintenance, deactivation, answer to service
                        requests.
                      </p>
                      <p className={classes.textPrivacyImportant}>
                        b) To communicate with you.
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        If you indicate now or at a future time that you consent
                        to our doing so, we will maintain the personal
                        information you provide us with in order that we may:-
                      </p>
                      <ul className={classes.textPrivacyNormal}>
                        <li className={classes.textPrivacyNormal}>
                          Contact you to communicate you of services and
                          products we will be providing;
                        </li>
                        <li className={classes.textPrivacyNormal}>
                          Upon receiving and inquiry send you requested
                          information about our services or products; or
                        </li>
                        <li className={classes.textPrivacyNormal}>
                          Contact you with updates within the further
                          development of any products and/or services you’ve got
                          expressed interest in.
                        </li>
                      </ul>
                      <p className={classes.textPrivacyNormal}>
                        We consider that we may use your personal data and our
                        processing of that Personal Data will accordingly arise
                        within the course of pursuing our legitimate interests
                        as a business engaged in and committed to the success of
                        the education sector. Our emails provided on the basis
                        above will always have an opt-out option in respect of
                        further communications.
                      </p>
                      <p className={classes.textPrivacyImportant}>
                        c) To provide better user management.
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        Information collected in connection with the
                        registration of subscription/user account/service -
                        Educational Institution and/or Individual
                        Educators/Teachers:
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        We will collect and process the following data about you
                        (Educational Institution and/or Educators/Teachers)
                        which may include any staff engaged by yourself who
                        utilize the Platform in connection with
                        registration/student accounts management.
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        We will collect and process the following data provided
                        by you about your students:Student personal data,
                        Example: Date of birth, email address, Name, gender,
                        User name, and other in personal information to create a
                        student profile, Parent details including occupation and
                        education, Health information.
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        The information will be collected either from the person
                        to whom you have granted administrative rights on behalf
                        of the educational institution or directly from you in
                        case of the individual educator/teacher as the case may
                        be. The information is collected within the Platform or
                        as a result of any correspondence with us by phone,
                        e-mail or otherwise. Any data collected.
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        Student personal data may be collected. Such information
                        may be collected upon parental/guardian consent taken by
                        the education institution/educators/teachers as per
                        Terms of use of Service.
                      </p>
                      <p className={classes.textPrivacyImportant}>
                        d) To provide personalised learning experience.
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        The KNEURA Platform enables the educational institutions
                        and/or individual educators/teachers to use the services
                        on the Platform available to its students based on the
                        subscription agreement. The Learning Platform can only
                        be access by the students if the educational institution
                        or individual educator/teacher has approve the student
                        with the appropriate login or ID access code and the
                        student may be required to enter his name, username,
                        password, and date of birth etc.
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        The educational institution or an individual
                        educator/teacher to ensure that any student to whom they
                        intend to provide with login or an ID access code
                        (including, students under the age of 16) have, before
                        any such login or code is provided, obtained all
                        necessary consents and permissions (from a parent and/or
                        guardian) to use the Platform and for us to collect and
                        process any user data.
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        You are also reminded that upon a student attaining the
                        age of 16 there is a legal requirement to retake consent
                        directly from the student and we require the relevant
                        School to secure that consent.
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        As an Educator/Teacher you acknowledge and warrant that
                        you have and will provide all requisite authority from,
                        and on behalf of, the student including where relevant
                        the parent/guardian of the student and on behalf of the
                        educational institution to
                        <ul className={classes.textPrivacyNormal}>
                          <li className={classes.textPrivacyNormal}>
                            (i) for you to provide the Platform and make it
                            available to student users;{" "}
                          </li>
                          <li className={classes.textPrivacyNormal}>
                            (ii) allow the student to use the Platform and,{" "}
                          </li>
                          <li className={classes.textPrivacyNormal}>
                            (iii) and to make any User Data available to us in
                            connection with the use of the Platform on the terms
                            set out in our terms and conditions and this privacy
                            policy.{" "}
                          </li>
                        </ul>
                      </p>

                      <p className={classes.textPrivacyNormal}>
                        <span className={classes.textPrivacyImportant}>
                          Analytics Feature:
                        </span>
                        You explicitly grant camera and microphone permissions
                        to capture images, videos, video calls and record the
                        same for classroom analytics features.
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        We may collect and process such data for emotion
                        tracking and facial monitoring of students for our
                        analytics.
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        We believe that you, the user has prior permissions to
                        use the analytics feature for the classroom. In the case
                        of students below 16 years of age for the above purpose,
                        the you shall procure written permission from Guardian
                        /Parents as mentioned in EULA.
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        A student himself or his guardian/Parent(student under
                        16 years of age) can opt-out. The data collected for the
                        analytics purpose will be stored and processed
                        anonymously for limited analytics features for such
                        students to choose to opt-out.
                      </p>

                      <p className={classes.textPrivacyImportant}>
                        e) Technical information.
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        We will automatically collect the subsequent information
                        in connection with the educator/Teacher Users and
                        Student Users use of the Platform
                      </p>
                      <ul className={classes.textPrivacyNormal}>
                        <li className={classes.textPrivacyNormal}>
                          Information concerning Login, Internet protocol (IP
                          address); to connect the computer to the internet,
                          browser Version, Time-Zone setting. Browser, plug-in
                          (types & Version) operating system, and the user
                          device.
                        </li>
                        <li className={classes.textPrivacyNormal}>
                          Information concerning your visit including the date
                          and time of access, the duration of your visit to the
                          Platform, details of the Platform features which were
                          utilized during the visit and for how long, the
                          location from which the Platform was accessed page
                          response times;
                        </li>
                        <li className={classes.textPrivacyNormal}>
                          download errors, page interaction information (such as
                          scrolling, clicks, and mouse-overs);
                        </li>
                        <li className={classes.textPrivacyNormal}>
                          Much of this information are going to be collected
                          using cookies. For details of cookies and their use in
                          connection with the Platform please see our Cookies
                          Policy.
                        </li>
                      </ul>
                      <p className={classes.textPrivacyContext}>
                        7.Data Retention
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        Where we keep in touch with you to give you information
                        about KNEURA products and services we ask you from time
                        to time to check the Personal information that we hold
                        and we will be glad to update that in accordance with
                        your wishes. For Institutes Educator/teacher and
                        students involved with the KNEURA Learning Platform, our
                        agreement requires the School to provide us with
                        information concerning Educator/teacher and Student
                        (users) when any of that information changes (such as a
                        joining of a new Student or a change in the identity of
                        a member of staff to be provided with access to the
                        Platform).
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        We will retain your data in accordance with your
                        consent, or in accordance with any applicable terms in
                        the EULA Agreement and your use of any
                        functionality(service), and as required by applicable
                        law. You can apply different settings to messages, files
                        or other types of your personal information.
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        The deletion of such Personal information and other use
                        of the Service may result in the deletion and/or
                        de-identification of certain associated Other
                        Information. For more detail, please contact us at{" "}
                        <a
                          className={classes.textPrivacyLink}
                          href="mailto:compliance@kneura.com"
                        >
                          compliance@kneura.com
                        </a>
                        .
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        We may retain other information pertaining to you for as
                        long as necessary for the purposes described in this
                        Privacy Policy.
                      </p>

                      <p className={classes.textPrivacyContext}>
                        8. Keeping your Personal information up to Date
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        Where we keep in touch with you to give you information
                        about KNEURA and our services we ask you from time to
                        time to check the Personal information that we hold and
                        we will be glad to update that in accordance with your
                        wishes. For students and staff involved with the KNEURA
                        Learning Platform, our agreement with the school
                        requires the them to provide us with information
                        concerning Staff and Users when any of that information
                        changes (such as a new Student to be provided with
                        access to the Platform or a change in the identity of a
                        member of staff).
                      </p>

                      <p className={classes.textPrivacyContext}>
                        9. Unsubscribe and Right to have Personal information
                        Deleted
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        Where you have consented to contact being made by us
                        with you for any of the purposes mentioned above but you
                        no longer wish to receive emails from us or wish to
                        change your selections as to how or what our contact
                        with you should be please email us at the{" "}
                        <a
                          className={classes.textPrivacyLink}
                          href="mailto:compliance@kneura.com?subject=Email Unsubscribe"
                        >
                          compliance@kneura.com
                        </a>{" "}
                        with “Email Unsubscribe” in the subject heading. We will
                        act upon this as soon as practicable.
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        You may also wish to write to us at the address given in
                        at the beginning of this Policy.
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        If you choose to unsubscribe from our mailing lists we
                        will only make contact with you again in circumstances
                        where you have consented to our being re-provided with
                        your information and that contact is authorized by you.
                      </p>

                      <p className={classes.textPrivacyContext}>
                        10. Parental Consent
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        If you are a parent/guardian and believe that your child
                        have provided us with personal information, please
                        contact us. We do not knowingly collect personal
                        information form users under the age of 16 years
                        directly. on such an occasion, we delete personal
                        information from our servers upon communication by you.
                      </p>

                      <p className={classes.textPrivacyContext}>
                        11. COPPA and GDPR Compliant
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        We, contractually obligate schools/educators/teachers to
                        obtain parental consent that our services can be used in
                        compliance with COPPA, GDPR and any law regulates the
                        use of online service by an users under the age of 16.
                      </p>

                      <p className={classes.textPrivacyContext}>
                        12. Security of your Information
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        KNEURA uses appropriate, physical, managerial and
                        technical measures to help protect your personal
                        information. While we have taken reasonable steps to
                        secure the personal information provided by you. Please
                        be aware that despite our best efforts, no security
                        measures are absolutely secure, and no method of data
                        transmission can be guaranteed against any interception
                        or other type of misuse.
                      </p>

                      <p className={classes.textPrivacyContext}>
                        13. For Residents of EEA
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        We ensure the provision of GDPR, Hence, as rights framed
                        by the legislation for residents of Europe Economic Area
                        allows them to access, correct, update, restrict usage,
                        or erase personal information.
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        Such residents can do so at any time by contacting us
                        using the contact{" "}
                        <a
                          className={classes.textPrivacyLink}
                          href="mailto:compliance@kneura.com"
                        >
                          compliance@kneura.com
                        </a>{" "}
                        . We seek your consent as to whether or not we process
                        your personal data. The information includes details of
                        the purposes, categories of personal data and the
                        recipients of the personal data. You can revoke such
                        consent at any time or restrict such consent by
                        contacting us at{" "}
                        <a
                          className={classes.textPrivacyLink}
                          href="mailto:compliance@kneura.com"
                        >
                          compliance@kneura.com
                        </a>
                      </p>

                      <p className={classes.textPrivacyContext}>
                        14. Cookie Policy
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        A cookie is a type of small amount of data used as an
                        anonymous unique identifier that enable the device to be
                        identified by our system. In our website we allow
                        cookies to be configured at your preference to collect
                        information and to improve our Service. You will have
                        the option to opt-in. You may disable cookies at any
                        time by modifying browser preference.
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        You can learn more details about cookies from your
                        browser's "Help" menu. We will not use cookies or
                        collect any personal information for any purpose other
                        than those stated in this Privacy policy.
                      </p>

                      <p className={classes.textPrivacyContext}>
                        15. Use of YouTube API
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        Our KSAR (Knowledge Search And Ranking) features use the
                        YouTube API for searching and embedding videos, We do
                        not ask, access to your private information data on
                        YouTube, as such, by agreeing to These Terms you also
                        agree to YouTube's Terms of Service (
                        <a
                          className={classes.textPrivacyLink}
                          href="https://www.youtube.com/t/terms"
                          target="_blank"
                        >
                          https://www.youtube.com/t/terms
                        </a>
                        ).
                      </p>

                      <p className={classes.textPrivacyContext}>
                        16. Other important Privacy options
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        You have the right chosen “opt-out “ option to stop
                        marketing communications we may send you periodically.
                        You can exercise your right to restrict by clicking on
                        the "opt-out" option in the marketing emails.
                      </p>

                      <p className={classes.textPrivacyContext}>
                        17. Promotional events, Emails, and Communications
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        This website operates an email newsletter and/or notice
                        for promotional and event programs to subscribers about
                        products and services and promotional activities of this
                        website. By clicking on Sign Up, you hereby agree to
                        subscribe to the aforesaid program and to receive, from
                        time to time, the aforesaid email newsletters and/or
                        notices. Should you wish to do so, you can unsubscribe
                        through an online-automated process contained in the
                        aforesaid email newsletters and/or notices.
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        If you no longer wish to receive emails or other
                        communications from us, you may opt-out by changing
                        preferences at the time you register your account with
                        the Application or logging into your account at any time
                        change settings and updating your preferences.
                      </p>

                      <p className={classes.textPrivacyContext}>
                        18. Policy Updates16. Other important Privacy options
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        As and when required, we may update this policy. This
                        website may revise the privacy policy when necessary,
                        and the revisions will be posted on this website. We may
                        update this Policy from time to time and comply with the
                        relevant local privacy laws and regulations. When we
                        make significant changes, we will make an announcement
                        on our official website.
                      </p>
                      <p className={classes.textPrivacyNormal}>
                        If you do not agree with any part of this Policy or any
                        amended content, you may discontinue the use of the
                        product immediately. If significant changes are made we
                        will notify all our users. By using our services, you
                        consent to this policy.
                      </p>

                      <p className={classes.textPrivacyContext}>CONTACT US</p>
                      <p className={classes.textPrivacyImportant}>
                        Please contact us regarding Privacy policy:
                      </p>

                      <span className={classes.textPrivacyImportant}>
                        Registered Offices:
                      </span>
                      <span className={classes.displayBlock}>
                        CYBERNETYX Interaktiv
                      </span>
                      <span className={classes.displayBlock}>
                        Cybernetyx Interaktiv UG (Haftungsbeschränkt),
                        Georgstraße 38, 30159 Hannover, Germany
                      </span>
                      <span className={classes.displayBlock}>
                        <a
                          className={classes.textPrivacyLink}
                          href="mailto:info.germany@cybernetyx.com"
                        >
                          info.germany@cybernetyx.com
                        </a>
                      </span>
                      <p></p>
                      <span className={classes.textPrivacyImportant}>
                        Product Support :
                      </span>
                      <span className={classes.displayBlock}>
                        CYBERNETYX Technik Private Limited, C98, Sector-65,
                        NOIDA - 201301, NCR (India)
                      </span>

                      <span className={classes.displayBlock}>
                        <a
                          className={classes.textPrivacyLink}
                          href="mailto:info.india@cybernetyx.com"
                        >
                          info.india@cybernetyx.com
                        </a>
                      </span>
                    </div>
                  </div>
                </div>

                <p
                  className="link"
                  onClick={() => setPrivacyDisplay(!privacyDisplay)}
                >
                  {privacyDisplay ? "Read Less" : "Read More"}
                </p>
              </Typography>
            </ExpansionPanelDetails>
          </ExpansionPanel>
        </div>
      </DialogContentText>
      <Button className={classes.closeButton} onClick={props.termsPageClose}>
        CLOSE
      </Button>
    </Dialog>
  );
}
// "btn-primary col-md-12"
